import React from 'react';

import { LearningCertificateSettingsProps } from '../../types';

export const LearningCertificateSettings: React.FC<LearningCertificateSettingsProps> = () => {
    return <div />;
};
